<div class="MessageModal">
    <mat-toolbar>
        <h3>{{ title }} </h3>
    </mat-toolbar>
        <mat-dialog-content><br/>
            <span  class="mt-25" [innerHTML]="body"></span><br/>
            
        </mat-dialog-content>
        <mat-dialog-actions style="float:right">
            <button mat-dialog-close mat-button mat-raised-button color="accent" (click)="goToHome()">{{ "ok" | translate }}</button>
        </mat-dialog-actions>
  </div>